export default __webpack_public_path__ + "static/media/JavaScript.36bb4d11.png";